import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import faviconUrl from "./public/faa8733677711f5e76f5629a776fe076.jpeg";

function App() {
  useEffect(() => {
    const existing =
      document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
      document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');

    const link = existing ?? document.createElement("link");
    link.rel = "icon";
    link.type = "image/jpeg";
    link.href = faviconUrl;

    if (!existing) document.head.appendChild(link);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
